import './AddCandidateSection.css';
import React, { useState, useEffect, useCallback } from 'react';
import { addCandidate } from '../../logic/candidatesLogic';
import { loadTestConfigs } from '../../logic/testConfigLogic';

export default function AddCandidateSection({ notify, can }) {
  const [configs, setConfigs] = useState([]);
  const [candidateForm, setCandidateForm] = useState({ email:'', full_name:'', phone:'', department:'', position:'', test_config_id:'' });
  const [busy, setBusy] = useState({});
  const isBusy = key => !!busy[key];
  const withBusy = async (key, fn) => {
    setBusy(b => ({ ...b, [key]: true }));
    try { await fn(); } finally { setBusy(b => ({ ...b, [key]: false })); }
  };

  const loadConfigs = useCallback(async () => {
    try {
      const configs = await loadTestConfigs();
      setConfigs(configs);
    } catch (e) { notify(e.response?.data?.message || 'Failed to load configs', true); }
  }, [notify]);

  useEffect(() => { loadConfigs(); }, [loadConfigs]);

  const createCandidate = async e => {
    e.preventDefault();
    await withBusy('create-candidate', async () => {
      try {
        const result = await addCandidate(candidateForm);
        notify(`Created "${result.username}" — email sent to ${result.email}`);
        setCandidateForm({ email:'', full_name:'', phone:'', department:'', position:'', test_config_id:'' });
      } catch (err) { notify(err.response?.data?.message || 'Failed', true); }
    });
  };

  return (
    <div className="create-form-wrap fade-up">
      <div className="info-banner"><span>🔐</span><div>
        <strong>Auto-generated credentials</strong>
        <p>A secure username and random password are generated automatically and emailed to the candidate.</p>
      </div></div>
      {can('candidates','edit') ? (
        <form onSubmit={createCandidate} className="create-form">
          <div className="form-section"><h3>Profile Information</h3>
            <div className="form-grid">
              <div className="input-group" style={{gridColumn:'1/-1'}}>
                <label>Full Name *</label>
                <input name="full_name" className="input-field" placeholder="John Doe"
                  value={candidateForm.full_name} onChange={e=>setCandidateForm(f=>({...f,full_name:e.target.value}))} required/>
              </div>
              <div className="input-group">
                <label>Email Address *</label>
                <input name="email" type="email" className="input-field" placeholder="john@company.com"
                  value={candidateForm.email} onChange={e=>setCandidateForm(f=>({...f,email:e.target.value}))} required/>
              </div>
              <div className="input-group">
                <label>Phone</label>
                <input name="phone" className="input-field" placeholder="+91 98765 43210"
                  value={candidateForm.phone} onChange={e=>setCandidateForm(f=>({...f,phone:e.target.value}))}/>
              </div>
              <div className="input-group">
                <label>Department</label>
                <input name="department" className="input-field" placeholder="Engineering"
                  value={candidateForm.department} onChange={e=>setCandidateForm(f=>({...f,department:e.target.value}))}/>
              </div>
              <div className="input-group">
                <label>Position Applied For</label>
                <input name="position" className="input-field" placeholder="Software Engineer"
                  value={candidateForm.position} onChange={e=>setCandidateForm(f=>({...f,position:e.target.value}))}/>
              </div>
              <div className="input-group" style={{gridColumn:'1/-1'}}>
                <label>Assign Test Config</label>
                <select className="input-field" value={candidateForm.test_config_id}
                  onChange={e=>setCandidateForm(f=>({...f,test_config_id:e.target.value}))}>
                  <option value="">— Use global active config —</option>
                  {configs.map(c=>(
                    <option key={c.id} value={c.id}>
                      {c.title}{c.is_active?' (Active)':''} · {c.total_questions}Q · {c.duration_minutes}min
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={isBusy('create-candidate')}>
              {isBusy('create-candidate') ? <><span className="btn-spinner"/>Sending…</> : '✚ Create & Send Email'}
            </button>
            <button type="button" className="btn btn-outline" onClick={()=>setCandidateForm({email:'',full_name:'',phone:'',department:'',position:'',test_config_id:''})}>Reset</button>
          </div>
        </form>
      ) : (
        <div className="empty-state"><span>🔒</span><p>You do not have permission to create candidates.</p></div>
      )}
    </div>
  );
}
